import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { api, ErrorResponse } from "@/utils/api";
import { underscore } from "@/utils/api-helpers";

export type FeedbackContext = {
  url: string;
  userAgent: string;
  userId: string;
  email: string;
  timestamp: string;
};

export type SubmitFeedbackInput = {
  message: string;
  context: FeedbackContext;
};

export const useSubmitFeedback = (
  options: Omit<UseMutationOptions<void, ErrorResponse, SubmitFeedbackInput, unknown>, "mutationFn"> = {}
) => {
  return useMutation<void, ErrorResponse, SubmitFeedbackInput, unknown>({
    mutationFn: async (input: SubmitFeedbackInput): Promise<void> => {
      await api.post("/feedback", underscore(input));
    },
    ...options
  });
};
